import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({ providedIn: "root" })
export class LanguageService {
  public languages: string[] = ["pt", "en", "es"];

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
  ) {}

  init(): Promise<void> {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang("pt");

    let lang = "pt";

    if (this.cookieService.check("lang")) {
      const cookieLang = this.cookieService.get("lang");
      // Normaliza variantes (pt-br → pt, en-us → en)
      lang = this.languages.includes(cookieLang)
        ? cookieLang
        : this.languages.find((l) => cookieLang.startsWith(l)) || "pt";
    } else {
      const browserLang = this.translate.getBrowserLang();
      lang = browserLang?.match(/^(pt|en|es)/)?.[1] || "pt";
      this.cookieService.set("lang", lang);
    }

    return new Promise((resolve) => {
      this.translate.use(lang).subscribe({
        next: () => resolve(),
        error: () => resolve(),
      });
    });
  }

  public setLanguage(lang: any) {
    this.translate.use(lang);
    this.cookieService.set("lang", lang);
  }
}
